skrilla.controller('queryUserAccountIdModalCtrl', function ($scope, searchService, cacheService, modalService, currencyService) {
    $scope.pageKey = "accounts";
    $scope.currency = "AUD";
    $scope.systemAccountCurrencies = currencyService.getCurrencies();
    $scope.accounts = cacheService.getObjectOrElse("userAccountsTable", []);
    if($scope.accounts.length > 0){
        $scope.currency = $scope.accounts[0].currency;
    }

    $scope.clicked = function(accounts, purpose, user){
        const userId = user.id;
        let account = accounts.filter(function(account){ return account.purpose === purpose });
        if (account.length === 0) {
            searchService.get("users/" + userId + "/accounts?currency=" + $scope.currency + "&createRequired=true").then(function (response) {
              account = response.data.filter(function(account){ return account.purpose === purpose });
              if (account.length === 0) {
                console.log("Still cant get " + purpose + " account for " + userId);
              } else {
                account[0].ownerName = user.username
              }
              cacheService.registerObject("queryUserAccount", account[0]);
              modalService.dismissAll();
            });
        } else {
          account[0].ownerName = user.username
          cacheService.registerObject("queryUserAccount", account[0]);
          modalService.dismissAll();
        }
    }


    $scope.systemClicked = function(account){
      account.ownerName = 'System'
      cacheService.registerObject("queryUserAccount", account);
        modalService.dismissAll();
    }

    $scope.getAccount = function(accounts, purpose){
        return accounts.filter(function(account){ return account.purpose == purpose })[0];
    }

});
